import { Field, fieldClass, Group, labelClass } from "./BriefField";
import { PROJECT_TYPES, SERVICE_OPTIONS } from "@/hooks/useBriefForm";

const serviceTestId = (s) => `brief-service-${s.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`;

export const BriefProject = ({ form, errors, set, toggleService }) => (
  <Group id="02" title="The Project">
    <Field
      label="Project Type"
      htmlFor="brief-project-type"
      error={errors.project_type}
      errorTestId="brief-error-project-type"
    >
      <select
        id="brief-project-type"
        data-testid="brief-project-type-select"
        className={fieldClass}
        value={form.project_type}
        onChange={set("project_type")}
        aria-invalid={!!errors.project_type}
      >
        <option value="">Select a project type</option>
        {PROJECT_TYPES.map((t) => (
          <option key={t} value={t}>
            {t}
          </option>
        ))}
      </select>
    </Field>

    <div>
      <span className={labelClass}>Services Required</span>
      <div className="flex flex-wrap gap-3">
        {SERVICE_OPTIONS.map((s) => {
          const active = form.services.includes(s);
          return (
            <button
              key={s}
              type="button"
              data-testid={serviceTestId(s)}
              aria-pressed={active}
              onClick={() => toggleService(s)}
              className={`rounded-full border px-5 py-2.5 font-mono text-[10px] uppercase tracking-[0.22em] transition-colors duration-300 ${
                active
                  ? "border-[#8B5CF6]/70 bg-[#8B5CF6]/20 text-[#F4F6FB]"
                  : "border-white/10 text-[#F4F6FB]/55 hover:border-[#8B5CF6]/40 hover:text-[#F4F6FB]"
              }`}
            >
              {s}
            </button>
          );
        })}
      </div>
      {errors.services && (
        <p data-testid="brief-error-services" className="mt-3 text-xs text-[#f87171]">
          {errors.services}
        </p>
      )}
    </div>

    <Field
      label="Project Description"
      htmlFor="brief-description"
      error={errors.description}
      errorTestId="brief-error-description"
    >
      <textarea
        id="brief-description"
        data-testid="brief-description-input"
        rows={5}
        maxLength={4000}
        className={`${fieldClass} resize-none`}
        value={form.description}
        onChange={set("description")}
        placeholder="What are we building, and what does it need to feel like?"
        aria-invalid={!!errors.description}
      />
    </Field>

    <div className="grid gap-7 md:grid-cols-2">
      <Field label="Main Objective" hint="optional" htmlFor="brief-objective">
        <textarea
          id="brief-objective"
          data-testid="brief-objective-input"
          rows={3}
          maxLength={1000}
          className={`${fieldClass} resize-none`}
          value={form.objective}
          onChange={set("objective")}
          placeholder="What does success look like?"
        />
      </Field>
      <Field label="Target Audience" hint="optional" htmlFor="brief-audience">
        <textarea
          id="brief-audience"
          data-testid="brief-audience-input"
          rows={3}
          maxLength={1000}
          className={`${fieldClass} resize-none`}
          value={form.audience}
          onChange={set("audience")}
          placeholder="Who is this for?"
        />
      </Field>
    </div>
  </Group>
);

export default BriefProject;
